import React from 'react';
import checkboxChecked from '../assets/investor-pricing/checkbox-checked.png';
import checkboxFrame from '../assets/investor-pricing/checkbox-frame.png';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  id: string;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  hasError?: boolean;
  align?: 'start' | 'center';
  boxSize?: 'md' | 'sm';
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  id,
  className = '',
  labelClassName,
  disabled = false,
  hasError = false,
  align = 'start',
  boxSize = 'md',
}) => {
  const boxClass = boxSize === 'sm' ? 'h-5 w-5' : 'h-6 w-6 sm:h-7 sm:w-7';
  return (
    <div
      className={`flex gap-2.5 ${align === 'center' ? 'items-center' : 'items-start'} ${className}`}
    >
      <button
        type="button"
        id={id}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`flex ${boxClass} shrink-0 items-center justify-center overflow-visible bg-transparent p-0 ${
          align === 'start' && !labelClassName ? 'mt-[1px] sm:mt-0' : ''
        } ${
          hasError ? 'ring-2 ring-red-500/40 ring-offset-1 ring-offset-black' : ''
        } ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
        role="checkbox"
        aria-checked={checked}
        aria-invalid={hasError}
        aria-labelledby={`${id}-label`}
      >
        <img
          src={checked ? checkboxChecked : checkboxFrame}
          alt=""
          className="pointer-events-none h-full w-full object-contain object-center"
          aria-hidden="true"
        />
      </button>
      <label
        htmlFor={id}
        id={`${id}-label`}
        className={`${
          labelClassName ?? 'text-xs leading-5 sm:text-sm'
        } ${hasError ? 'text-red-400' : 'text-white'} ${
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
